var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-list',{attrs:{"fileType":2,"fileList":_vm.fileList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }